import AccountTypeCard from './AccountTypeCard';
export default AccountTypeCard;
